import InputField from 'components/formComponents/Base/InputField';
import { UnionSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';
type Props = {
  texts?: UnionSectionTexts;
};

const UnionContact = ({ texts }: Props) => {
  return (
    <>
      <InputField
        name="unionContactFirstname"
        label={texts?.unionContactFirstname?.label ?? 'Förnamn'}
        placeholder={
          texts?.unionContactFirstname?.placeholder ?? 'Ange förnamn'
        }
        required
      />
      <InputField
        name="unionContactLastname"
        label={texts?.unionContactLastname?.label ?? 'Efternamn'}
        placeholder={
          texts?.unionContactLastname?.placeholder ?? 'Ange efternamn'
        }
        required
      />
      <InputField
        name="unionContactPhone"
        label={texts?.unionContactTelephone?.label ?? 'Telefon'}
        placeholder={
          texts?.unionContactTelephone?.placeholder ?? 'Ange telefonnummer'
        }
        required
      />
      <InputField
        name="unionContactEmail"
        label={texts?.unionContactEmail?.label ?? 'E-post'}
        placeholder={texts?.unionContactEmail?.placeholder ?? 'exempel@mail.se'}
        required
      />
      <InputField
        name="unionContactConfirmEmail"
        label={texts?.unionContactConfirmEmail?.label ?? 'Bekräfta e-post'}
        placeholder={
          texts?.unionContactConfirmEmail?.placeholder ?? 'Bekräfta e-post'
        }
        required
      />
      <InputField
        name="unionContactAddress"
        label={texts?.unionContactAddress?.label ?? 'Adress'}
        placeholder={texts?.unionContactAddress?.placeholder ?? 'Ange adress'}
      />
      <InputField
        name="unionContactCity"
        label={texts?.unionContactCity?.label ?? 'Ort'}
        placeholder={texts?.unionContactCity?.placeholder ?? 'Ange ort'}
      />
      <InputField
        name="unionContactPostalCode"
        label={texts?.unionContactPostalCode?.label ?? 'Postnummer'}
        placeholder={
          texts?.unionContactPostalCode?.placeholder ?? 'Ange postnummer'
        }
      />
    </>
  );
};

export default UnionContact;
